var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.attachments),function(attachment,index){return _c('attachment-thumbnail',{key:attachment.attachmentId,attrs:{"messageIndex":_vm.messageIndex,"attachmentIndex":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }